<template>
  <va-card :title="$t('menu.products_by_pallets')">
    <div class="row">
      <div class="flex xs6 sm3">
        <va-date-picker
          :label="$t('tables.date')"
          v-model="date"
        />
      </div>

      <div class="flex xs6 sm3">
        <va-select
          v-model="selected_operation"
          :options='daily_operations'
          label="Operação"
          textBy="operation_name"
          keyBy="id"
          clearable="false"
          placeholder="Selecione a operação desejada"
        />
      </div>

      <div class="flex xs6 sm3">
        <va-button
          medium
          inline
          color="green"
          icon="fa fa-download"
          class="ma-0"
          @click="exportProductsByPalletsReport(selected_operation)"
        >
          {{ $t('menu.export') }}
        </va-button>
      </div>

    </div>

    <va-data-table
      :fields="fields"
      :data="products_by_pallets"
      :per-page="15"
      :loading="loading"
      >
    </va-data-table>
  </va-card>
</template>

<script>

import IndicatorsAPI from '@/services/IndicatoresAPI'
import moment from 'moment'
import { mapState } from "vuex"
import DailyOperationAPI from '@/services/DailyOperationAPI'

export default {
  data () {
    return {
      products_by_pallets: [],
      loading: false,
      now: new moment(),
      interval: '',
      data: [],
      date: '',
      dateSelected: '',
      daily_operations: [],
      selected_operation: '',
      filepath: "",
    }
  },

  channels: {
    NeedRefreshMountingTimes: {
      received(data) {
        this.getProductsByPallets()
      },
    }
  },

  watch: {
    '$store.state.currentLocality': function() {
      this.getProductsByPallets()
    },
    paramRole: function() {
      this.getProductsByPallets()
    }
  },

  mounted () {
    const yesterday = new Date()
    yesterday.setDate(yesterday.getDate() - 1)
    this.date = yesterday
    this.getDailyOperations(yesterday, this.currentLocality.id)

    this.$cable.subscribe({ channel: 'NeedRefreshMountingTimes', company: this.currentUser.company })
    this.getProductsByPallets(this.selected_operation)
    this.interval = setInterval(() => { this.now = new moment() }, 1000)
  },

  beforeDestroy(){
    window.clearInterval(this.interval);
  },

  methods: {
    exportProductsByPalletsReport(operation){
      IndicatorsAPI.exportProductsByPalletsReport(operation.id).then(response => {
        let url = process.env.VUE_APP_API_BASE_URL.replace("api/v1", "")
        let link = document.createElement('a')
        this.filepath = url + response.data.filename
        document.body.appendChild(link)
        link.href=this.filepath

        this.showToast(response.data.message, {
          icon: 'fa-thumbs-o-up',
          position: 'top-right',
          duration: 5000,
        })
        link.click()
      }).catch(e => {
        this.showToast(e.response.data.error, {
          icon: 'fa-thumbs-o-down',
          position: 'top-right',
          duration: 5000,
        })
      });
    },

    async getProductsByPallets(operation){
      this.loading = true

      await IndicatorsAPI.getProductsByPallets(operation.id).then(response => {
        this.products_by_pallets = response.data.products_by_pallets
        this.loading = false
      })
    },

    async getDailyOperations(date, localityID){
      this.loading = true

      DailyOperationAPI.getDailyOperations(date, localityID).then(response => {
        this.daily_operations = response.data.daily_operations

        if (this.daily_operations.length > 0 ){
          this.selected_operation = this.daily_operations[0]
        } else {
          this.data = []
          this.selected_operation = ''
        }

        this.loading = false
      }).catch(e => {showError(e); this.loading = false })
    },
  },
  watch: {
    date: function(newDate, oldDate) {
      this.getDailyOperations(newDate, this.currentLocality.id)
    },

    selected_operation: function(operation){
      if (operation != ''){
        this.getProductsByPallets(operation)
      } else {
        this.products_by_pallets = []
      }
    },

    '$store.state.currentLocality': function() {
      this.getDailyOperations(this.date, this.currentLocality.id)
    }
  },

  computed: {
    ...mapState(['currentUser', 'currentLocality']),

    fields () {
      return [{
        name: 'integration_id',
        title: this.$t('tables.products_by_pallets.integration_id'),
      },
      {
        name: 'product_name',
        title: this.$t('tables.products_by_pallets.product_name'),
      },
      {
        name: 'package',
        title: this.$t('tables.products_by_pallets.package'),
      },
      {
        name: 'pallet_mixed_total',
        title: this.$t('tables.products_by_pallets.pallet_mixed_total'),
      },
      {
        name: 'pallet_mixed_loaded',
        title: this.$t('tables.products_by_pallets.pallet_mixed_loaded'),
      },
      {
        name: 'pallet_complete_total',
        title: this.$t('tables.products_by_pallets.pallet_complete_total'),
      },
      {
        name: 'pallet_complete_loaded',
        title: this.$t('tables.products_by_pallets.pallet_complete_loaded'),
      }

      ]
    }
  }
}
</script>
